import React, { useEffect, useState } from "react"
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Collapse,
    Form,
    FormFeedback,
    Spinner,
    Alert
} from "reactstrap"
import Select from "../Components/Select"
import Tooltip from "../Components/Tooltip"
import { useWallet } from "../libs/useMetaMaskWallet"
import Web3 from "web3"
import votingJSON from "../../src/abi/SpendableVotingByStakeNFTHolder.json" //change to stake spendable voting
import ConnectWallet from "../Components/ConnectWallet"
import BreadCrumb from "../Components/BreadCrumb"
import classnames from "classnames"
import { COMMENT_KEYS } from "@babel/types"
import { convertDataToVotingDetails, timeToEpoch, setMinPollDateRange } from "../utils"
import stakeMirrorJSON from "../../src/abi/StakePoolFlexLock.json" //change to stake flex
import DateRangePicker from "@wojtekmaj/react-daterange-picker"
import SpinnerWrap from "../Components/SpinnerWrap"
import LoadingOrErrorCard from "../Components/LoadingOrErrorCard/LoadingOrErrorCard"

const stakeNFTContract = "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C" // IGSPvZ
const nftMeStakeContract = ""
const l3stakeContract = ""
const votingContract = "0x5F082E16CD4d13d264441d962234e4344A23847e"
const ropstenVoteContract = "0x3194232434d4058f83603b5006ab400d3cd10bb8"
const apiUrl = `https://voting.idexo.io/`

const SortDirection = [
    {
        label: "Oldest First",
        value: "Oldest first"
    },
    {
        label: "Newest First",
        value: "Newest first"
    }
]

const VotingNew = () => {
    const web3 = new Web3(window.ethereum || window.web3)
    const [activeTab, setActiveTab] = useState("1")
    const [searchOpen, isSearchOpen] = useState(false)
    const [selectedSortDirection, setSelectedSortDirection] = useState(SortDirection[0])
    const [search, setSearch] = useState("")
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [pollDetails, setPollDetails] = useState([]) // array of objects, where each object refers to a poll to vote on { description:"str", id:int, address, choices:[] }
    const [filteredPollDetails, setFilteredPollDetails] = useState([])
    const [pollIsOpen, setPollIsOpen] = useState({}) // for setting collapsed/expanded poll view- { pollId:boolean, ... }
    // all polls will default to being open (for now)

    const [isHolder, setIsHolder] = useState(false)

    const [loading, setLoading] = useState(true)
    const [errorLoading, setErrorLoading] = useState("") // if error from fetching poll/voting details
    const [pollQuestion, setPollQuestion] = useState("")
    const [multipleChoiceAnswers, setMultipleChoiceAnswers] = useState(["", ""]) // values refer to user inputs for multiple choice answers
    const [showSpinner, setShowSpinner] = useState(false) // loading animation on buttons
    const [alertMessage, setAlertMessage] = useState("")
    const [alertColor, setAlertColor] = useState("")
    const [createdPoll, setCreatedPoll] = useState(false) // true if user just clicked "submit" button in create votes tab
    const [popoverIdOpen, setPopoverIdOpen] = useState(false)
    const [pollDateRange, setPollDateRange] = useState(() => setMinPollDateRange(7)) // callback only runs once on initial mount, setMinPollDateRange returns array of start/end dates
    const [pollDuration, setPollDuration] = useState(7) // num of days poll will last

    const toggle = () => setPopoverIdOpen(null)

    const wallet = useWallet()

    const tooltipText = "You do not have the Mirror NFT token required to vote."

    useEffect(async () => {
        if (activeTab) {
            setAlertMessage("")
        }
    }, [activeTab])

    useEffect(() => {
        const questions = pollDetails.filter((question) => question.description.toLowerCase().includes(search.toLowerCase()))
        setFilteredPollDetails(questions)
    }, [search, pollDetails])

    useEffect(async () => {
        let changed = false
        let votedPolls = localStorage.getItem("votedPolls")?.split(",") || []
        for (let i = 0; i < pollDetails.length; i++) {
            if (pollDetails[i].voted === undefined) {
                try {
                    changed = true
                    pollDetails[i].changed = new Date().getTime()
                    const contract = new web3.eth.Contract(votingJSON.abi, pollDetails[i].contract)
                    pollDetails[i].voted = await contract.methods.checkIfVoted(pollDetails[i].pollId, wallet.account).call()
                    if (pollDetails[i].voted) votedPolls.push(pollDetails[i].id)
                } catch (error) {
                    console.log(error)
                }
            }
        }
        if (changed) {
            setPollDetails(pollDetails)
            localStorage.setItem("votedPolls", votedPolls)
        }
    }, [pollDetails])

    const voteFunction = async (pollDetail) => {
        let votedPolls = localStorage.getItem("votedPolls")?.split(",") || []
        //=> Ex. [ "137fbb50-32aa-11ec-9113-09b8a2ebcbb2", "e7831540-3841-11ec-8ed4-1fd389205fdd" ]

        if (pollDetail.voted || votedPolls.includes(pollDetail.id)) {
            pollDetail.alertMessage = "You already voted!"
            setAlertColor("danger")
            return
        }

        setShowSpinner(true)
        try {
            const contract = new web3.eth.Contract(votingJSON.abi, pollDetail.contract)
            await contract.methods
                .castVote(pollDetail.pollId, pollDetail.vote)
                .send({
                    from: wallet.account,
                    gas: 320000,
                    gasPrice: "55000000000"
                })
                .on("receipt", (receipt) => {
                    pollDetail.alertMessage = "Success! Vote Submitted!"
                    setAlertColor("success")

                    votedPolls.push(pollDetail.id) // add new unique poll id to array
                    localStorage.setItem("votedPolls", votedPolls)
                })

            setShowSpinner(false)
        } catch (err) {
            console.log(err)
            setShowSpinner(false)
            setAlertColor("danger")
            pollDetail.alertMessage = "ERROR: Transaction has been reverted by the EVM"
        }
    }

    // collapses/expands poll detail row in available votes tab
    const togglePoll = (pollIdx) => {
        // first render, pollIsOpoen will be an empty object, so need to manually set it to false
        if (pollIsOpen[pollIdx] === undefined) {
            setPollIsOpen({ ...pollIsOpen, [pollIdx]: false }) // false == default when page first renders is to display all polls
        } else {
            setPollIsOpen({ ...pollIsOpen, [pollIdx]: !pollIsOpen[pollIdx] })
        }
    }

    const isEveryStrDiff = (arr) => {
        let table = {}
        for (let i = 0; i < arr.length; i++) {
            if (table[arr[i]] !== undefined) return false
            table[arr[i]] = i
        }
        return true
    }

    // for poll date range form validation
    useEffect(() => {
        if (pollDateRange) {
            // get num of days between start and end date
            const start = pollDateRange[0]
            const end = pollDateRange[1]
            const timeDiff = end.getTime() - start.getTime() // in milliseconds
            const differenceInDays = timeDiff / (1000 * 3600 * 24) // number of days between start and end date

            // set alert if num of days is less than 7
            if (differenceInDays < 7) {
                setAlertMessage("Minimum Poll Duration is 7 days!")
                setAlertColor("danger")
            } else {
                setAlertMessage("")
            }

            setPollDuration(differenceInDays)
        }
    }, [pollDateRange])

    // creates new poll
    const handleSubmitCreateVote = (event) => {
        event.preventDefault()
        if (!isEveryStrDiff(multipleChoiceAnswers)) {
            setAlertMessage("Every choice must be different!")
            setAlertColor("danger")
            return
        }

        if (!isHolder) {
            setAlertMessage("You must have an idexo Stake NFT to create a poll!")
            setAlertColor("danger")
            return
        }

        setShowSpinner(true)
        setCreatedPoll(true)

        // convert dates (js date obj) to milliseconds from epoch (UTC)
        const startTime = pollDateRange[0].getTime() + 600000 // add 10 minutes to start time or else smart contract will error out
        const endTime = pollDateRange[1].getTime()

        try {
            fetch(apiUrl, {
                method: "POST",
                headers: { token: localStorage.jwtToken, "Content-Type": "application/json" },
                body: JSON.stringify({
                    description: pollQuestion,
                    start_time: timeToEpoch(startTime), // convert to seconds
                    end_time: timeToEpoch(endTime),
                    minimum_stake_time: 1,
                    options: multipleChoiceAnswers,
                    creator: wallet.account
                })
            })
                .then((res) => res.json())
                .then((data) => {
                    setShowSpinner(false)
                    if (data.error) {
                        setAlertMessage("Error: " + data.error)
                        setAlertColor("danger")
                    } else {
                        setAlertMessage("Success! Poll Submitted!")
                        setAlertColor("success")
                    }
                })
        } catch (err) {
            setShowSpinner(false)
            setAlertMessage("ERROR: " + err.message)
            setAlertColor("danger")
        }
    }

    const handleAddChoice = (_e) => {
        let choicesCopy = multipleChoiceAnswers.slice()
        choicesCopy.push("")
        setMultipleChoiceAnswers(choicesCopy)
    }

    const handleRemoveChoice = (index) => {
        // shallow copy old state so we don't modify it directly
        let choicesCopy = multipleChoiceAnswers.slice()

        // delete key/value pair in copy
        choicesCopy.splice(index, 1)

        setMultipleChoiceAnswers(choicesCopy)
    }

    const isFormValid = () => {
        return pollQuestion.replace(/\s/g, "") && multipleChoiceAnswers.every((choice) => choice)
    }

    // returns true if poll question description, that user typed in, already exists
    const isDescriptionDuplicate = () => {
        return pollDetails.some((pollDetail) => pollQuestion.toLowerCase() === pollDetail.description.toLowerCase())
    }

    const fetchPollDetails = async () => {
        setLoading(true)
        setErrorLoading("")
        try {
            const res = await fetch(apiUrl, { method: "GET", headers: { token: localStorage.jwtToken } })
            const data = await res.json()
            const questions = []
            let votedPolls = localStorage.getItem("votedPolls")?.split(",") || []
            data.data.Items.forEach((e) => {
                let q = convertDataToVotingDetails(e)
                if (votedPolls.includes(q.id)) q.voted = true
                questions.push(q)
            })
            setPollDetails(questions)
            setLoading(false)
        } catch (err) {
            console.log(err)
            setLoading(false)
            setErrorLoading(String(err))
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === 324 // zkSync
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(async () => {
        if (updateConnection() && wallet.account) {
            let mirror = new web3.eth.Contract(stakeMirrorJSON.abi, stakeNFTContract) //check for more than one contract here
            const holding = await mirror.methods.isHolder(wallet.account).call()
            setIsHolder(holding)
            await fetchPollDetails()
        }
    }, [wallet.account, wallet.status, wallet.chainId])

    return (
        <React.Fragment>
            <div className="content voting-page">
                <BreadCrumb items={["Voting"]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={324} onChange={updateConnection} />
                ) : (
                    <div className="voting-body">
                        <div className="tabs-and-search">
                            <div className="tab-links">
                                <span className={classnames({ active: activeTab === "1" })} onClick={() => setActiveTab("1")}>
                                    Available Votes
                                </span>
                                <span className={classnames({ active: activeTab === "2" })} onClick={() => setActiveTab("2")}>
                                    Create Votes
                                </span>
                            </div>

                            {/* TO DO: ADD SEARCH BAR / FILTER FUNCTIONALITY */}
                            {activeTab === "1" && (
                                <div className="d-flex align-items-center search-filter-wrap">
                                    {!searchOpen ? (
                                        <div className="sort-by">
                                            <label>Sort by</label>
                                            <div className="sort-select">
                                                <Select
                                                    value={selectedSortDirection}
                                                    onChange={setSelectedSortDirection}
                                                    options={SortDirection}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="search">
                                            <div className="search-input">
                                                <input
                                                    id="searchInput"
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    placeholder="Search"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <Button color="primary" className="search-btn" onClick={() => isSearchOpen(!searchOpen)}>
                                        <i className="bx bx-search" />
                                    </Button>
                                </div>
                            )}
                        </div>

                        <TabContent activeTab={activeTab}>
                            <TabPane className="show" tabId="1">
                                {loading ? (
                                    <LoadingOrErrorCard loadingTxt={"Poll Details"} backgroundColor="white" />
                                ) : (
                                    <React.Fragment>
                                        {/* if no questions/poll details (empty arr), show empty card */}
                                        {pollDetails.length === 0 && !errorLoading && (
                                            <LoadingOrErrorCard emptyTxt={"There are no votes"} icon="bx bx-poll" backgroundColor="white" />
                                        )}

                                        {/* if error fetching poll deatils, show error card */}
                                        {errorLoading && (
                                            <LoadingOrErrorCard errorTxt={"the Poll Details"} alertMessage={errorLoading} backgroundColor="white" />
                                        )}

                                        {/* render polls if no errors or polls not empty */}
                                        {filteredPollDetails.map((pollDetail, idx) => {
                                            return (
                                                <Row key={idx}>
                                                    <Col>
                                                        <Card>
                                                            <CardBody>
                                                                <Col>
                                                                    <CardTitle className="h3 poll-details">
                                                                        <Button
                                                                            className={
                                                                                "expand-collapse-button " +
                                                                                (pollIsOpen[idx + 1] === undefined || pollIsOpen[idx + 1]
                                                                                    ? "rotate"
                                                                                    : "")
                                                                            }
                                                                            color="secondary"
                                                                            onClick={() => togglePoll(idx + 1)}
                                                                        >
                                                                            <i className="bx bx-chevron-right" />
                                                                        </Button>
                                                                        <span className="poll-details">Poll Details</span>
                                                                    </CardTitle>
                                                                </Col>
                                                                <Row>
                                                                    <Col>
                                                                        <CardText className="P text-uppercase mb-1 description">
                                                                            Description: {pollDetail.description}
                                                                        </CardText>
                                                                    </Col>
                                                                </Row>
                                                                <Row></Row>

                                                                <Collapse isOpen={pollIsOpen[idx + 1] === undefined || pollIsOpen[idx + 1]}>
                                                                    {/* if user already voted in this specific poll detail */}
                                                                    {pollDetail.end_time < Date.now() / 1000 ? (
                                                                        <CardTitle className="h3 option">Poll already ended!</CardTitle>
                                                                    ) : pollDetail.start_time > Date.now() / 1000 ? (
                                                                        <CardTitle className="h3 option">Poll has not started!</CardTitle>
                                                                    ) : pollDetail.voted ? (
                                                                        <CardTitle className="h3 option">You already voted!</CardTitle>
                                                                    ) : (
                                                                        <React.Fragment>
                                                                            <CardTitle className="h3 option">Choose an option</CardTitle>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <FormGroup className="mb-2">
                                                                                        {pollDetail.choices.map((choice, i) => {
                                                                                            return (
                                                                                                <Row key={i}>
                                                                                                    <Col>
                                                                                                        <Label>
                                                                                                            <Input
                                                                                                                type="radio"
                                                                                                                name={pollDetail.id}
                                                                                                                onChange={(_e) =>
                                                                                                                    (pollDetail.vote = i + 1)
                                                                                                                }
                                                                                                                disabled={showSpinner}
                                                                                                            />
                                                                                                            {choice.description}
                                                                                                        </Label>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            )
                                                                                        })}

                                                                                        <Row>
                                                                                            {pollDetail.alertMessage ? (
                                                                                                <Alert
                                                                                                    color={alertColor}
                                                                                                    toggle={() => (pollDetail.alertMessage = "")}
                                                                                                >
                                                                                                    {pollDetail.alertMessage}
                                                                                                </Alert>
                                                                                            ) : null}
                                                                                            <Tooltip
                                                                                                title={tooltipText}
                                                                                                placement="top"
                                                                                                open={popoverIdOpen === idx && !isHolder}
                                                                                                onClose={toggle}
                                                                                                onOpen={() => setPopoverIdOpen(idx)}
                                                                                            >
                                                                                                <span>
                                                                                                    <Button
                                                                                                        color="primary"
                                                                                                        className="waves-effect w-lg w-100"
                                                                                                        onClick={() => voteFunction(pollDetail)}
                                                                                                        disabled={
                                                                                                            pollDetail.vote === undefined ||
                                                                                                            showSpinner ||
                                                                                                            !isHolder
                                                                                                        }
                                                                                                    >
                                                                                                        <SpinnerWrap
                                                                                                            showSpinner={showSpinner}
                                                                                                            txtTrue={"VOTING"}
                                                                                                            txtFalse={"VOTE"}
                                                                                                        />
                                                                                                    </Button>
                                                                                                </span>
                                                                                            </Tooltip>
                                                                                        </Row>
                                                                                    </FormGroup>
                                                                                </Col>
                                                                            </Row>
                                                                        </React.Fragment>
                                                                    )}
                                                                </Collapse>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </React.Fragment>
                                )}
                            </TabPane>

                            <TabPane className="show" tabId="2">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitCreateVote}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="full-name" className="form-label">
                                                    <CardTitle className="h3 create-votes">Enter Your Poll Question</CardTitle>
                                                </Label>
                                                {isDescriptionDuplicate() ? <Alert color="danger">This question already exists!</Alert> : null}
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    id="poll-question"
                                                    placeholder="Enter Poll Question"
                                                    name="poll-question"
                                                    onChange={(e) => setPollQuestion(e.target.value)}
                                                    disabled={showSpinner}
                                                />
                                                <FormFeedback>Must enter a poll question!</FormFeedback>
                                            </FormGroup>
                                            <React.Fragment>
                                                <CardTitle className="h3 create-votes">Enter Choices (Minimum Two)</CardTitle>

                                                {multipleChoiceAnswers.map((choice, idx) => {
                                                    return (
                                                        <Row key={idx} className="choices-row">
                                                            <Col className="choices-col">
                                                                <FormGroup className="mb-3">
                                                                    <Input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={`Enter Choice ${idx + 1}`}
                                                                        name={`choice-${idx + 1}`}
                                                                        value={choice}
                                                                        onChange={(e) => {
                                                                            // shallow copy old state so we don't modify state directly
                                                                            let choicesCopy = multipleChoiceAnswers.slice()
                                                                            choicesCopy[idx] = e.target.value
                                                                            setMultipleChoiceAnswers(choicesCopy)
                                                                        }}
                                                                        disabled={showSpinner}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            {/* If there are 3 or more choices, display remove choice button on each row */}
                                                            {multipleChoiceAnswers.length >= 3 && (
                                                                <Col className="remove-col">
                                                                    <Button
                                                                        className="remove-choice"
                                                                        onClick={() => handleRemoveChoice(idx)}
                                                                        disabled={showSpinner}
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    )
                                                })}

                                                <FormGroup>
                                                    <Button className="waves-effect w-lg add-choice" onClick={handleAddChoice} disabled={showSpinner}>
                                                        Add Choice
                                                    </Button>
                                                </FormGroup>
                                            </React.Fragment>

                                            {alertMessage ? (
                                                <Alert color={alertColor} toggle={() => setAlertMessage("")}>
                                                    {alertMessage}
                                                </Alert>
                                            ) : null}

                                            <Row>
                                                <FormGroup className="mb-3">
                                                    <CardTitle className="h3 create-votes">Choose Poll Duration (Min 7 Days)</CardTitle>
                                                    <DateRangePicker onChange={setPollDateRange} value={pollDateRange} minDate={new Date()} />
                                                </FormGroup>
                                            </Row>

                                            <Button
                                                color="primary"
                                                className="waves-effect w-lg"
                                                style={{ width: "100%" }}
                                                disabled={
                                                    !isFormValid() ||
                                                    showSpinner ||
                                                    isDescriptionDuplicate() ||
                                                    createdPoll ||
                                                    !pollDateRange ||
                                                    pollDuration < 7
                                                }
                                            >
                                                <SpinnerWrap showSpinner={showSpinner} txtTrue={"SUBMITTING POLL"} txtFalse={"SUBMIT"} />
                                            </Button>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </TabPane>
                        </TabContent>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default VotingNew
